import { render, staticRenderFns } from "./FinanceSalarySliceShowTable.vue?vue&type=template&id=0029c0ef&scoped=true&"
import script from "./FinanceSalarySliceShowTable.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceShowTable.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalarySliceShowTable.vue?vue&type=style&index=0&id=0029c0ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029c0ef",
  null
  
)

export default component.exports